// import React, { Component } from 'react';
// import { Link } from 'react-router-dom';

// class PrivacyPolicy extends Component {
//     componentDidMount(){
//         window.scrollTo(0,0);
//      }
//     render() {
//         return (
//             <div>
//             <section className="section breedcrumb">
//                <div className="breedcrumb__img-wrapper">
//                    <img src="assets/images/banner/breedcrumb.jpg" alt="breedcrumb" />
//                    <div className="container">
//                    <ul className="breedcrumb__content">
//                        <li>
//                        <Link to="index.html">
//                        <i className="fa fa-home iconss"></i>
//                            <span> {'>'} </span>
//                        </Link>
//                        </li>
//                        <li className="active"><span className="breadcrumb-target">Privacy Policy</span></li>
//                    </ul>
//                    </div>
//                </div>
//                </section>

//                <section className="section section--xl faq">
//                     <div className="container">
//                         <div className="row faq__content">
//                             <div className="col-lg-12 order-lg-0 order-2">
//                                 <div className="faq__accordion">
//                                     <h2 className="font-title--md text-left">Terms & Conditions</h2>
//                                     <p><strong>Rio Aarman Hardware Pvt Ltd</strong></p>
//                                     <p>Effective Date: 12th Oct 2018<br />
//                                        Registered in Maharashtra, India</p>
                                    
//                                     <hr />

//                                     <h5 className="font-title--sm text-left">1. Company and Scope</h5>
//                                     <p>We trade, wholesale, and retail hardware, sanitary fittings, fixtures, flat glass, and related tools and accessories. These Terms apply to all orders, enquiries, quotations, catalog browsing, and purchase transactions made through our website, physical store, wholesale network, WhatsApp, email, or direct communication.</p>

//                                     <h5 className="font-title--sm text-left">2. Catalogue and Product Information</h5>
//                                     <p>Our website functions as a catalogue for enquiry purposes only. Product descriptions, technical specifications, visual materials, and availability are indicative and may vary slightly in appearance, finish, or dimension due to manufacturing tolerances.</p>

//                                     <h5 className="font-title--sm text-left">3. Orders and Pricing</h5>
//                                     <p>Prices are not displayed online and are communicated upon enquiry. All prices are exclusive of GST unless otherwise stated. GST is applied at the applicable rate at the time of billing. Orders are confirmed only upon our acceptance and issuance of invoice or confirmation message.</p>

//                                     <h5 className="font-title--sm text-left">4. Payment Terms</h5>
//                                     <p>We accept cash, UPI, cheque, and bank transfer. No credit terms are offered. Payment must be completed prior to dispatch unless otherwise agreed in writing.</p>

//                                     <h5 className="font-title--sm text-left">5. Shipping, Delivery, and Risk</h5>
//                                     <p>We deliver using our own logistics and third-party carriers. Risk of damage remains with us during transit and until the goods reach the delivery point. Customers may inspect goods upon delivery. Upon inspection and acceptance, risk transfers to the customer. Claims for visible damage must be raised at the time of delivery.</p>

//                                     <h5 className="font-title--sm text-left">6. Warranty</h5>
//                                     <p>All products carry a limited warranty of up to six months from date of purchase against manufacturing defects only. No warranty applies to misuse, improper handling, corrosion, installation errors, normal wear-and-tear, or usage beyond intended purpose. Warranty claims require proof of purchase (invoice).</p>

//                                     <h5 className="font-title--sm text-left">7. Returns, Replacement, and Refunds</h5>
//                                     <p>We do not accept returns for non-defective products. In the case of manufacturing defects, replacement, repair, or refund may be issued at our discretion after inspection and verification by us. We determine whether a defect is manufacturing-related. Situational refunds may be offered in select cases.</p>

//                                     <h5 className="font-title--sm text-left">8. Installation and Liability</h5>
//                                     <p>We do not provide installation services. We are not liable for injury, damage, or loss resulting from misuse, improper installation, unprofessional handling, or modification of products. Customers are responsible for safe usage and compliance with recommended handling practices.</p>

//                                     <h5 className="font-title--sm text-left">9. Dealer Network</h5>
//                                     <p>Wholesale dealers transact verbally without separate written agreements. All dealer orders follow these Terms unless otherwise agreed in writing. No credit is extended to dealers unless explicitly granted.</p>

//                                     <h5 className="font-title--sm text-left">10. Communications and Marketing</h5>
//                                     <p>By engaging with us through website enquiry, WhatsApp, calls, or email, customers consent to receive communication related to orders, enquiries, promotional offers, and product launches. Customers may opt out of promotional communication at any time.</p>

//                                     <h5 className="font-title--sm text-left">11. International Sales</h5>
//                                     <p>We currently sell only within India. International sales may be added in future and may involve separate terms.</p>

//                                     <h5 className="font-title--sm text-left">12. Intellectual Property</h5>
//                                     <p>All content, product images, and materials in our catalogue or website are owned by Rio Aarman Hardware Pvt Ltd and may not be used without permission.</p>

//                                     <h5 className="font-title--sm text-left">13. Limitation of Liability</h5>
//                                     <p>To the fullest extent permitted by law, our liability is limited to the invoice value of the goods in dispute. We are not liable for indirect, incidental, or consequential damages including property damage, installation cost, or loss of use.</p>

//                                     <h5 className="font-title--sm text-left">14. Disputes and Jurisdiction</h5>
//                                     <p>All disputes are subject to Mumbai jurisdiction. Any unresolved disputes may be referred to arbitration in Mumbai as per the Arbitration and Conciliation Act, 1996.</p>

//                                     <h5 className="font-title--sm text-left">15. Force Majeure</h5>
//                                     <p>We are not liable for delays or failures caused by events beyond reasonable control including supply chain disruptions, transport failures, strikes, natural events, or regulatory changes.</p>
                                    
//                                     <p className="mt-4"><em>Continued engagement indicates acceptance of the latest version of these terms.</em></p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//        </div>
//         );
//     }
// }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class PrivacyPolicy extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const sections = [
            { id: "collection", title: "1. Data We Collect", text: "We collect customer information required for enquiry, billing, logistics, and communication including name, phone, email, GST, and address. We also collect device data and IP for security." },
            { id: "communication", title: "2. Communication", text: "We use WhatsApp, calls, SMS, and email for orders and promotions. By contacting us, you consent to receive such communication, with opt-out available for promotions." },
            { id: "usage", title: "3. Data Usage", text: "Data is used for processing enquiries, generating invoices, logistics coordination, tax compliance, and customer support based on contractual necessity." },
            { id: "sharing", title: "4. Third-Party Sharing", text: "We share data only with parties required for logistics, delivery, or accounting. We do not sell, rent, or trade your personal information." },
            { id: "cookies", title: "5. Cookies", text: "Our website uses cookies and analytics tools to improve performance, security, and user experience." },
            { id: "retention", title: "6. Data Retention", text: "Data is retained for statutory tax and accounting periods and for the purpose of business continuity." },
            { id: "security", title: "7. Data Security", text: "We implement technical safeguards to protect data; however, no electronic transmission is entirely risk-free." },
            { id: "children", title: "9. Children’s Data", text: "We do not knowingly collect data from minors. All customers engaging in transactions must be adults under Indian law." },
            { id: "rights", title: "10. Your Rights", text: "Customers may request data correction or opt out of promotional communication at any time." }
        ];

        return (
            <div className="privacy-page" style={{ backgroundColor: '#f4f7f6', minHeight: '100vh' }}>
                
                {/* HEADER SECTION */}
                <section className="privacy-header" style={{ background: '#1a1a1a', padding: '80px 0 60px 0' }}>
                    <div className="container">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb" style={{ background: 'transparent', padding: 0, marginBottom: '20px' }}>
                                <li className="breadcrumb-item"><Link to="/" style={{ color: '#00d2ff' }}>Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: '#eee' }}>Privacy Policy</li>
                            </ol>
                        </nav>
                        <h1 style={{ color: '#fff', fontSize: '3rem', fontWeight: '800', marginBottom: '10px' }}>
                            Privacy Policy
                        </h1>
                        <p style={{ color: '#00d2ff', fontSize: '1.1rem', letterSpacing: '1px' }}>
                            Rio Aarman Hardware Pvt Ltd | <span style={{ color: '#fff' }}>Effective: 12th Oct 2018</span>
                        </p>
                    </div>
                </section>

                {/* CONTENT SECTION */}
                <section className="privacy-body" style={{ marginTop: '-30px', paddingBottom: '80px' }}>
                    <div className="container">
                        <div className="row">
                            
                            {/* Sticky Sidebar */}
                            <div className="col-lg-3 d-none d-lg-block">
                                <div className="card shadow-sm border-0" style={{ position: 'sticky', top: '100px', borderRadius: '12px' }}>
                                    <div className="card-body">
                                        <h6 className="text-muted mb-3" style={{ fontSize: '0.8rem', letterSpacing: '1px' }}>POLICY SECTIONS</h6>
                                        <ul className="list-unstyled">
                                            {sections.map(s => (
                                                <li key={s.id} className="mb-2 pb-2 border-bottom">
                                                    <a href={`#${s.id}`} style={{ color: '#333', textDecoration: 'none', fontSize: '0.85rem', fontWeight: '500' }}>
                                                        {s.title}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Main Policy Content */}
                            <div className="col-lg-9">
                                <div className="card shadow border-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                    <div className="card-body p-5" style={{ backgroundColor: '#fff' }}>
                                        <div className="mb-5 pb-3 border-bottom">
                                            <h3 style={{ color: '#2d3436', fontWeight: '700' }}>Your Privacy Matters</h3>
                                            <p className="text-muted">We are committed to protecting your personal data and being transparent about how we use it.</p>
                                        </div>

                                        {sections.map(section => (
                                            <div key={section.id} id={section.id} className="mb-5">
                                                <h5 style={{ fontWeight: '700', color: '#1a1a1a', marginBottom: '15px' }}>
                                                    {section.title}
                                                </h5>
                                                <p style={{ lineHeight: '1.8', color: '#444', fontSize: '1.05rem' }}>
                                                    {section.text}
                                                </p>
                                            </div>
                                        ))}

                                        <div className="mt-5 p-4" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #00d2ff', borderRadius: '4px' }}>
                                            <h6 style={{ fontWeight: '700' }}>11. Changes to Policy</h6>
                                            <p className="mb-0" style={{ fontSize: '0.95rem', color: '#666' }}>
                                                This policy may be updated periodically. Continued engagement with Rio Aarman Hardware Pvt Ltd indicates acceptance of the latest version.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default PrivacyPolicy;